import { useModules } from '@/services/Modules';

export const useModuleByName = (name: string | undefined) => {
	const { data, isLoading, isError } = useModules();
	const module = data?.find((mod) => mod.name === name);

	return { module, isLoading, isError, notFound: !!data && !module };
};
